module.exports = __webpack_public_path__ + "static/img/ggtqw.e420f74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/ggtqw.jpg
// module id = cD5y
// module chunks = 0